module.exports = __webpack_public_path__ + "static/media/icon-character__stefan-zweig-hover.32752bd3.svg";